import React from "react";
import {
  Select as MuiSelect,
  SelectProps,
  useTheme,
  FormControl,
  InputLabel,
} from "@mui/material";
import { tokens } from "../../theme";

type CustomSelectProps = SelectProps & {
  label: string;
};

const CustomSelect: React.FC<CustomSelectProps> = ({
  label,
  sx,
  children,
  ...props
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <FormControl fullWidth>
      <InputLabel
        sx={{
          color: colors.primary[300],
          "&.Mui-focused": {
            color: "#614438",
          },
        }}
      >
        {label}
      </InputLabel>
      <MuiSelect
        label={label}
        sx={{
          borderRadius: "8px",
          "& .MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${colors.primary[300]}`,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#614438",
          },
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
          },
          ...sx,
        }}
        {...props}
      >
        {children}
      </MuiSelect>
    </FormControl>
  );
};

export default CustomSelect;
